'use client'

import * as Select from '@radix-ui/react-select'
import * as TabsPrimitive from '@radix-ui/react-tabs'

import {
  useTabsListVariant,
  useTabsTriggerRenderMode,
  useTabsValue,
} from '~/components/component-library/Tabs/context'
import {
  TABS_SELECT_ITEM_CLASSNAME,
  TABS_TRIGGER_BASE_CLASSNAME,
  TABS_TRIGGER_CLASSNAME,
} from '~/components/component-library/Tabs/styles'
import { type TabsTriggerProps } from '~/components/component-library/Tabs/types'
import { cn } from '~/utils/tailwind-utils'

const TabsOptionItem = ({ value, isDisabled, children }: TabsTriggerProps) => (
  <Select.Item
    value={value}
    disabled={isDisabled}
    className={TABS_SELECT_ITEM_CLASSNAME}
  >
    <Select.ItemText>{children}</Select.ItemText>
  </Select.Item>
)

// The dropdown's label is the active trigger's children; the rest render nothing
const TabsActiveLabel = ({ value, children }: TabsTriggerProps) => {
  const { value: activeValue } = useTabsValue()
  return value === activeValue ? children : null
}

const TabsRowTrigger = ({
  ref,
  isDisabled,
  className,
  ...props
}: TabsTriggerProps) => {
  const variant = useTabsListVariant()

  return (
    <TabsPrimitive.Trigger
      ref={ref}
      disabled={isDisabled}
      className={cn(
        TABS_TRIGGER_BASE_CLASSNAME,
        TABS_TRIGGER_CLASSNAME[variant],
        {
          'cursor-not-allowed opacity-40': isDisabled,
          'data-[state=inactive]:hover:text-primary': !isDisabled,
        },
        className,
      )}
      {...props}
    />
  )
}

export const TabsTrigger = (props: TabsTriggerProps) => {
  const renderMode = useTabsTriggerRenderMode()

  if (renderMode === 'option') return <TabsOptionItem {...props} />
  if (renderMode === 'label') return <TabsActiveLabel {...props} />
  return <TabsRowTrigger {...props} />
}
